var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.724H8.828A8.829 8.829 0 0 1 0 414.896V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.792a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M512 220.69H291.31V88.276h-70.621V220.69H0v70.62h220.689v132.414h70.621V291.31H512z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.93 282.483v-52.966l-13.241 13.242H163.31l-13.241-13.242v52.966l13.241-13.242h185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.517 361.931h52.965l-13.241-13.242V163.311l13.241-13.242h-52.965l13.241 13.242v185.378z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/gg.be5ce7b8009fbdfbf8eac4a3e67f9316.svg";
export { ForwardRef as ReactComponent };